import React, { Component } from 'react';
import { Row, Col, Divider, Icon, Tooltip, Tag, List, Card, Popconfirm, message } from 'antd';
import { Link } from 'react-router-dom'
import { Customer, Menu } from '../../../../services/api';
import { CurrentWeek } from '../../../../components/Date';
import Search from '../../../../components/Search';
import AddButton from '../grocery-list/AddButton';
import SaveMenu from './SaveMenu';
import Week from './Week';
import MenuCollage from './MenuCollage';
import CreateMenu from './CreateMenu';

export default class MenuList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: {},
            currentWeekMenu: null,
            menus: [],
            allocatedWeeks: [],
            searchResult: [],
            featuredMenus: [],
            searchQuery: '',
            loading: {
                customer: false,
                menu: false,
                search: false,
                featured: false,
                delete: {}
            },
        };

        this.customerApi = new Customer(props);
        this.menuApi = new Menu(props);
    }

    componentDidMount() {
        this.fetchCustomer();
        this.fetchFeaturedMenus();
    }

    fetchCustomer = () => {
        const { loading } = this.state;
        loading.customer = true;
        this.setState({ loading });
        this.customerApi.me()
            .then(res => {
                this.setState({ customer: res.data.data });
                this.listMenus();
            })
            .catch(() => {
                this.customerApi.retry({ cb: this.fetchCustomer });
                loading.customer = false;
                this.setState({ loading });
            });
    }

    fetchFeaturedMenus = () => {
        const { loading } = this.state;
        loading.featured = true;
        this.setState({ loading });

        this.menuApi.listFeatured()
            .then(res => {
                loading.featured = false;
                this.setState({ loading, featuredMenus: res.data.data });
            })
            .catch((err) => {
                this.menuApi.retry({ cb: this.fetchFeaturedMenus });
                loading.featured = false;
                this.setState({ loading });
            });
    }

    listMenus = () => {
        const { customer, loading } = this.state;
        if (!customer) {
            loading.customer = false;
            this.setState({ loading });
            return;
        }

        this.customerApi.raw().get(customer._links.menus.href)
            .then(res => {
                res.data.data.forEach(m => {
                    this.fetchOrigin(m);
                });

                loading.customer = false;
                this.setState({ loading });
            })
            .catch(_ => {
                this.customerApi.retry({ cb: this.listMenus });
            });
    }

    search = (query) => {
        const { loading } = this.state;
        loading.search = true;
        this.setState({ loading, searchQuery: query });

        this.menuApi.search(query)
            .then(res => {
                let nextPage = null;
                if (res.data._links.nextPage) {
                    nextPage = res.data._links.nextPage.href;
                }

                loading.search = false;
                this.setState({ searchResult: res.data.data, loading, nextPage });
            })
            .catch(_ => {
                this.menuApi.retry({ params: [query], cb: this.search });
            });
    }

    searchByTags = (tags) => {
        const query = tags.join(', ');
        const { loading } = this.state;
        loading.search = true;

        this.setState({ loading, searchQuery: query });

        this.menuApi.searchByTags(tags)
            .then(res => {
                let nextPage = null;
                if (res.data._links.nextPage) {
                    nextPage = res.data._links.nextPage.href;
                }

                loading.search = false;
                this.setState({ searchResult: res.data.data, loading, nextPage });
            })
            .catch(_ => {
                this.menuApi.retry({ params: [tags], cb: this.searchByTags });
            });
    }

    clearSearch = () => {
        this.setState({ searchresult: [], searchQuery: '' });
    }

    fetchOrigin = (menu) => {
        this.customerApi.raw().get(menu._links.origin.href)
            .then(res => {
                const { menus } = this.state;
                let { allocatedWeeks } = this.state;
                menu.origin = res.data.data;
                menus.push(menu);
                allocatedWeeks = allocatedWeeks.concat(menu.weeks);

                if (menu.weeks && menu.weeks.indexOf(CurrentWeek()) !== -1) {
                    this.setState({ currentWeekMenu: menu });
                }
                this.setState({ menus, allocatedWeeks });
            })
            .catch(() => {
                this.customerApi.retry({ params: [menu], cb: this.fetchOrigin });
            });
    }

    delete = (menu) => {
        const { loading, menus } = this.state;
        let { allocatedWeeks } = this.state;

        loading.delete[menu.id] = true;
        this.setState({ loading });

        this.customerApi.raw().delete(menu._links.delete.href)
            .then(() => {
                message.success(`${menu.origin.title} har blivit raderad.`);
                loading.delete[menu.id] = false;

                const index = menus.findIndex(m => m.id === menu.id);
                menus.splice(index, 1);

                allocatedWeeks = allocatedWeeks.filter(w => menu.weeks.indexOf(w) === -1);

                if (menu.weeks && menu.weeks.indexOf(CurrentWeek()) !== -1) {
                    this.setState({ currentWeekMenu: null });
                }
                this.setState({ loading, menus, allocatedWeeks });
            })
            .catch(_ => {
                this.customerApi.retry({ params: [menu], cb: this.delete });
            });
    }

    menuAdded = (menu) => {
        if (!menu.origin._embedded) {
            this.fetchOrigin(menu);
            return;
        }
        const { menus } = this.state;
        let { allocatedWeeks } = this.state;
        menus.push(menu);
        allocatedWeeks = allocatedWeeks.concat(menu.weeks);

        if (menu.weeks && menu.weeks.indexOf(CurrentWeek()) !== -1) {
            this.setState({ currentWeek: menu });
        }
        this.setState({ menus, allocatedWeeks });
    }

    existingMenu = (menu) => {
        return this.state.menus.find(m => m.origin.id === menu.id);
    }

    render() {
        const { loading, menus, featuredMenus, searchResult, searchQuery, customer, currentWeekMenu, allocatedWeeks } = this.state;
        
        return (
            <Row>
                <Search
                    placeholder="Sök menyer"
                    onSearch={this.search}
                    onTagSearch={this.searchByTags}
                    onClear={this.clearSearch}
                    loading={loading.search}
                    useTags
                />

                <Col span={24}>
                    {(searchQuery === '' && featuredMenus.length > 0) && (
                        <div>
                            <Divider>Redaktörerna rekommenderar</Divider>
                            <List
                                grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 3 }}
                                loading={loading.search}
                                dataSource={featuredMenus}
                                renderItem={item => (
                                    <List.Item>
                                        <Card
                                            cover={(
                                                <Link to={{
                                                    pathname: this.existingMenu(item) !== undefined ? `/customers/${customer.id}/menus/${this.existingMenu(item).id}` : `/menus/${item.id}`,
                                                    state: { customer: customer, menus: menus }
                                                }}>
                                                    <MenuCollage menu={item} />
                                                </Link>
                                            )}
                                            actions={[
                                                <span>
                                                    <SaveMenu
                                                        iconOnly
                                                        exists={this.existingMenu(item) !== undefined}
                                                        menu={item}
                                                        allocatedWeeks={allocatedWeeks}
                                                        customer={customer}
                                                        onSave={this.menuAdded}
                                                    />
                                                </span>
                                            ]}
                                        >
                                            <Link to={{
                                                pathname: this.existingMenu(item) !== undefined ? `/customers/${customer.id}/menus/${this.existingMenu(item).id}` : `/menus/${item.id}`,
                                                state: { customer: customer, menus: menus }
                                            }}>
                                                <List.Item.Meta
                                                    title={item.title}
                                                />
                                            </Link>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                        </div>
                    )}

                    {searchQuery && (
                        <div>
                            <Divider>Sökresultat för: {searchQuery}</Divider>
                            <List
                                grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 3 }}
                                loading={loading.search}
                                dataSource={searchResult}
                                locale={{ emptyText: `Inget resultat hittdes för: ${searchQuery}` }}
                                renderItem={item => (
                                    <List.Item>
                                        <Card
                                            cover={(
                                                <Link to={{
                                                    pathname: this.existingMenu(item) !== undefined ? `/customers/${customer.id}/menus/${this.existingMenu(item).id}` : `/menus/${item.id}`,
                                                    state: { customer: customer, menus: menus }
                                                }}>
                                                    <MenuCollage menu={item} />
                                                </Link>
                                            )}
                                            actions={[
                                                <span>
                                                    <SaveMenu
                                                        iconOnly
                                                        exists={this.existingMenu(item) !== undefined}
                                                        menu={item}
                                                        allocatedWeeks={allocatedWeeks}
                                                        customer={customer}
                                                        onSave={this.menuAdded}
                                                    />
                                                </span>
                                            ]}
                                        >
                                            <Link to={{
                                                pathname: this.existingMenu(item) !== undefined ? `/customers/${customer.id}/menus/${this.existingMenu(item).id}` : `/menus/${item.id}`,
                                                state: { customer, menus }
                                            }}>
                                                <List.Item.Meta
                                                    title={item.title}
                                                />
                                            </Link>
                                        </Card>
                                    </List.Item>
                                )}
                            />
                        </div>
                    )}

                    {currentWeekMenu && (
                        <div>
                            <Divider>Denna vecka</Divider>
                            <Week menu={currentWeekMenu.origin} loading={loading.menu} />
                        </div>
                    )}
                    
                    <Divider>Mina menyer</Divider>
                    <div style={{ textAlign: 'center', margin: '20px 0 40px 0' }}>
                        <CreateMenu 
                            customer={customer} 
                            allocatedWeeks={allocatedWeeks}
                            onSuccess={this.menuAdded}
                        />
                    </div>
                    

                    <List
                        grid={{ gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 3 }}
                        loading={loading.customer}
                        dataSource={menus}
                        locale={{ emptyText: 'Du har inga sprade menyer.' }}
                        renderItem={menu => (
                            <List.Item>
                                <Card
                                    cover={(
                                        <Link to={{
                                            pathname: `/customers/${customer.id}/menus/${menu.id}`,
                                            state: { menu, customer, menus }
                                        }}>
                                            <MenuCollage menu={menu.origin} />
                                        </Link>
                                    )}
                                    actions={[
                                        <Tooltip placement="bottom" title="Lägg till i inköpslista">
                                            <AddButton iconOnly menu={menu.origin} />
                                        </Tooltip>,
                                        <Tooltip placement="bottom" title="Radera">
                                            <Popconfirm
                                                title={`Ta bort ${menu.origin.title}`}
                                                onConfirm={() => { this.delete(menu) }}
                                                cancelText="Nej"
                                                okText="Ja"
                                            >
                                                {loading.delete[menu.id] ? <Icon type="loading" /> : <Icon type="delete" />}
                                            </Popconfirm>
                                        </Tooltip>
                                    ]}
                                >
                                    <Link to={{
                                        pathname: `/customers/${customer.id}/menus/${menu.id}`,
                                        state: { menu, customer, menus }
                                    }}>
                                        <List.Item.Meta
                                            title={`${menu.origin.title}`}
                                        />
                                    </Link>
                                    <div style={{marginTop: '10px'}}>
                                        {menu.weeks && menu.weeks.map(w => (
                                            <Tag key={w} color="volcano">v{w}</Tag>
                                        ))}
                                    </div>
                                </Card>
                            </List.Item>
                        )}
                    />
                </Col>
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/screens/dashboard/components/menu/MenuList.js